<template>
  <a-modal
      v-model:visible="visible"
      :title="isEditMode ? '修改客户账户' : '新增客户账户'"
      :on-before-ok="handleOk"
      @cancel="handleCancel"
      width="900px"
      :mask-closable="false"
      :ok-loading="loading"
      draggable
  >
    <a-form ref="formRef" :model="formData" :rules="rules" layout="vertical">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item label="账号编码" field="code">
            <a-input v-model="formData.code" placeholder="请输入账号编码" allow-clear />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="用户名" field="username">
            <a-input v-model="formData.username" placeholder="请输入用户名" allow-clear />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item label="登录密码" field="password">
            <a-input-password 
              v-model="formData.password" 
              :placeholder="isEditMode ? '不修改请留空' : '请输入登录密码'" 
              allow-clear 
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="昵称" field="nickname">
            <a-input v-model="formData.nickname" placeholder="请输入昵称" allow-clear />
          </a-form-item>
        </a-col>
      </a-row>

<!--      <a-row :gutter="24">-->
<!--        <a-col :span="8">-->
<!--          <a-form-item label="省" field="province">-->
<!--            <a-input v-model="formData.province" placeholder="请输入省" allow-clear />-->
<!--          </a-form-item>-->
<!--        </a-col>-->
<!--        <a-col :span="8">-->
<!--          <a-form-item label="市" field="city">-->
<!--            <a-input v-model="formData.city" placeholder="请输入市" allow-clear />-->
<!--          </a-form-item>-->
<!--        </a-col>-->
<!--        <a-col :span="8">-->
<!--          <a-form-item label="区/县" field="counties">-->
<!--            <a-input v-model="formData.counties" placeholder="请输入区/县" allow-clear />-->
<!--          </a-form-item>-->
<!--        </a-col>-->
<!--      </a-row>-->

<!--      <a-form-item label="详细地址" field="address">-->
<!--        <a-input v-model="formData.address" placeholder="请输入详细地址" allow-clear />-->
<!--      </a-form-item>-->

      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item label="手机号" field="phone">
            <a-input v-model="formData.phone" placeholder="请输入手机号" allow-clear />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="邮箱" field="email">
            <a-input v-model="formData.email" placeholder="请输入邮箱" allow-clear />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="性别" field="gender">
            <a-select v-model="formData.gender" placeholder="请选择性别" allow-clear>
              <a-option :value="3">未设置</a-option>
              <a-option :value="1">男</a-option>
              <a-option :value="2">女</a-option>
            </a-select>
          </a-form-item>
        </a-col>
<!--        <a-col :span="8">-->
<!--          <a-form-item label="用户类型" field="type">-->
<!--            <a-select v-model="formData.type" placeholder="请选择用户类型" allow-clear>-->
<!--              <a-option :value="0">管理员</a-option>-->
<!--              <a-option :value="1">员工</a-option>-->
<!--              <a-option :value="2">客户账号</a-option>-->
<!--            </a-select>-->
<!--          </a-form-item>-->
<!--        </a-col>-->
        <a-col :span="8">
          <a-form-item label="账号状态" field="status">
            <a-select v-model="formData.status" placeholder="请选择账号状态" allow-clear>
              <a-option value="0">正常</a-option>
              <a-option value="1">禁用</a-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

<!--      <a-row :gutter="24">-->
<!--        <a-col :span="12">-->
<!--          <a-form-item label="是否外包" field="outsource">-->
<!--            <a-switch v-model="formData.outsource" />-->
<!--          </a-form-item>-->
<!--        </a-col>-->
<!--        <a-col :span="12">-->
<!--          <a-form-item label="账号锁" field="locked">-->
<!--            <a-switch v-model="formData.locked" />-->
<!--          </a-form-item>-->
<!--        </a-col>-->
<!--      </a-row>-->

<!--      <a-form-item label="头像" field="avatar">-->
<!--        <a-input v-model="formData.avatar" placeholder="请输入头像URL" allow-clear />-->
<!--      </a-form-item>-->

<!--      <a-form-item label="扩展字段" field="extensionFields">-->
<!--        <a-textarea -->
<!--          v-model="formData.extensionFields" -->
<!--          placeholder="请输入JSON格式的扩展字段"-->
<!--          :rows="3"-->
<!--          allow-clear -->
<!--        />-->
<!--      </a-form-item>-->
    </a-form>
  </a-modal>
</template>

<script setup>
import { ref, watch, nextTick } from 'vue'
import { Message } from '@arco-design/web-vue'
import { 
  addCustomerAccount, 
  updateCustomerAccount, 
  getCustomerAccount 
} from '@/apis/customer-data'

// 定义 props
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  accountId: {
    type: [String, Number],
    default: null
  }
})

// 定义 emits
const emit = defineEmits(['update:modelValue', 'success'])

// 响应式数据
const visible = ref(false)
const loading = ref(false)
const formRef = ref()

// 判断是否为编辑模式
const isEditMode = ref(false)

// 表单数据
const formData = ref({
  id: null,
  code: '',
  username: '',
  password: '',
  nickname: '',
  // province: '',
  // city: '',
  // counties: '',
  // address: '',
  phone: '',
  email: '',
  gender: 3,
  // type: 2,
  // avatar: '',
  status: '0',
  // outsource: false,
  // locked: false,
  // extensionFields: ''
})

// 表单验证规则
const rules = ref({
  code: [
    { required: true, message: '请输入账号编码' },
    { min: 2, max: 50, message: '账号编码长度为2-50个字符' }
  ],
  username: [
    { required: true, message: '请输入用户名' },
    { min: 2, max: 50, message: '用户名长度为2-50个字符' }
  ],
  password: [
    { 
      validator: (value, callback) => {
        if (!isEditMode.value && !value) {
          callback('请输入登录密码')
          return
        }
        if (value && value.length < 6) {
          callback('密码长度不能少于6个字符')
          return
        }
        callback()
      }
    }
  ],
  nickname: [
    { min: 1, max: 50, message: '昵称长度为1-50个字符' }
  ],
  phone: [
    {
      match: /^1[3-9]\d{9}$/, 
      message: '请输入正确的手机号码' 
    }
  ],
  email: [
    {
      match: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 
      message: '请输入正确的邮箱地址' 
    }
  ],
  status: [
    { required: true, message: '请选择账号状态' }
  ]
})

// 监听 modelValue 变化
watch(() => props.modelValue, (newVal) => {
  visible.value = newVal
  if (newVal) {
    if (props.accountId) {
      isEditMode.value = true
      fetchAccountInfo()
    } else {
      isEditMode.value = false
      resetForm()
    }
  }
})

// 监听 visible 变化
watch(visible, (newVal) => {
  emit('update:modelValue', newVal)
})

// 重置表单
const resetForm = () => {
  formData.value = {
    id: null,
    code: '',
    username: '',
    password: '',
    nickname: '',
    // province: '',
    // city: '',
    // counties: '',
    // address: '',
    phone: '',
    email: '',
    gender: 3,
    // type: 2,
    // avatar: '',
    status: '0',
    // outsource: false,
    // locked: false,
    // extensionFields: ''
  }
  
  nextTick(() => {
    formRef.value?.clearValidate()
  })
}

// 获取账户信息
const fetchAccountInfo = async () => {
  if (!props.accountId) return
  
  loading.value = true
  try {
    const response = await getCustomerAccount(props.accountId)
    if (response.code === 0) {
      const data = response.data
      formData.value = {
        id: data.id,
        code: data.code || '',
        username: data.username || '',
        password: '', // 密码不回显
        nickname: data.nickname || '',
        // province: data.province || '',
        // city: data.city || '',
        // counties: data.counties || '',
        // address: data.address || '',
        phone: data.phone || '',
        email: data.email || '',
        gender: data.gender || 3,
        // type: data.type || 2,
        // avatar: data.avatar || '',
        status: data.status || '0',
        // outsource: data.outsource || false,
        // locked: data.locked || false,
        // extensionFields: typeof data.extensionFields === 'object' 
        //   ? JSON.stringify(data.extensionFields, null, 2) 
        //   : data.extensionFields || ''
      }
    } else {
      Message.error(response.message || '获取账户信息失败')
    }
  } catch (error) {
    Message.error('获取账户信息失败')
    console.error('获取账户信息失败:', error)
  } finally {
    loading.value = false
  }
}

// 处理确认按钮
const handleOk = async (done) => {
  try {
    // 验证表单
    const validateResult = await formRef.value?.validate()
    
    // 如果验证失败，阻止提交和关闭弹框
    if (validateResult !== undefined) {
      done(false)
      return false
    }
    
    loading.value = true
    
    // 准备提交数据
    const submitData = { ...formData.value }
    
    // 处理扩展字段
    // if (submitData.extensionFields) {
    //   try {
    //     submitData.extensionFields = JSON.parse(submitData.extensionFields)
    //   } catch (e) {
    //     Message.error('扩展字段格式不正确，请输入有效的JSON格式')
    //     loading.value = false
    //     return false
    //   }
    // }
    
    // 如果是编辑模式且密码为空，则不提交密码字段
    if (isEditMode.value && !submitData.password) {
      delete submitData.password
    }
    
    let response
    if (isEditMode.value) {
      response = await updateCustomerAccount(submitData)
    } else {
      delete submitData.id // 新增时删除id字段
      response = await addCustomerAccount(submitData)
    }
    
    if (response.code === 0) {
      Message.success(isEditMode.value ? '修改客户账户成功' : '新增客户账户成功')
      emit('success')
      visible.value = false
      done(true)
      return true
    } else {
      Message.error(response.message || `${isEditMode.value ? '修改' : '新增'}客户账户失败`)
      done(false)
    }
  } catch (error) {
    // 如果是表单验证错误，不显示网络错误提示
    if (error && typeof error === 'object' && error.name !== 'ValidateError') {
      Message.error(`${isEditMode.value ? '修改' : '新增'}客户账户失败`)
      console.error('操作失败:', error)
    }
    done(false)
    return false
  } finally {
    loading.value = false
  }
}

// 处理取消按钮
const handleCancel = () => {
  formRef.value?.clearValidate()
  visible.value = false
}
</script>

<style scoped>
.a-form-item {
  margin-bottom: 16px;
}
</style>